import { Command, CommandInput } from "@/components/ui/command"
import CustomSelect from "@/components/shared/CustomSelect/CustomSelect"
import { useTranslation } from "react-i18next"

interface ProductFiltersProps {
  search: string
  onSearchChange: (value: string) => void
  status?: string
  onStatusChange?: (value: string) => void
  showStatusFilter?: boolean
  onPageReset: () => void
}

export const ProductFilters = ({
  search,
  onSearchChange,
  status,
  onStatusChange,
  showStatusFilter = false,
  onPageReset
}: ProductFiltersProps) => {
  const { t } = useTranslation("common")

  const statusOptions = [
    { value: "active", label: t("common:status_option.active") },
    { value: "inactive", label: t("common:status_option.inactive") },
    { value: "blocked", label: t("common:status_option.blocked") },
    { value: "all", label: t("common:status_option.all") },
  ]

  const handleSearchChange = (value: string) => {
    onSearchChange(value)
  }

  const handleStatusChange = (value: string) => {
    onStatusChange?.(value)
  }

  return (
    <div className='flex flex-col md:flex-row gap-4'>
      <Command>
        <CommandInput
          placeholder={t('searchLabel')}
          value={search}
          onValueChange={handleSearchChange}
          className='w-full md:w-[336px]'
          data-cy='search-input'
        />
      </Command>

      {showStatusFilter && status && onStatusChange && (
        <div className='w-full md:w-[152px]'>
          <CustomSelect
            options={statusOptions}
            placeholder=''
            onValueChange={handleStatusChange}
            dataCy='select-status'
            value={status}
          />
        </div>
      )}
    </div>
  )
}
